import { fetchHelper } from 'src/app/fetch-helper';
import { apiEndPoint } from './api-endpoint';

export const summaryProvider = {
  getInfo(params: { customerId: number, finalPeriodId?: number }) {
    return fetchHelper<SummaryModel>(`${apiEndPoint.summary}`, 'GET', params);
  },
}
